import {FaHome} from "react-icons/fa"

const menuItems = [
    {name: "Home", link: "#", icon: <FaHome />},
    {name: "About me", link: "#"},
    {name: "Education", link: "#"},
    {name: "Portfolio", link: "#"},
    {name: "Contact", link: "#"},
]

export {menuItems}